// File: src/components/ErrorBoundary.tsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from './ui/Button';
import { StateBlock } from './ui/StateBlock';

interface ErrorBoundaryProps {
    children: React.ReactNode;
}

interface ErrorBoundaryState {
    hasError: boolean;
}

const Fallback = () => {
    const { t } = useTranslation();
    return (
        <div className="flex min-h-dvh items-center justify-center bg-page">
            <StateBlock
                variant="error"
                title={t('errors.boundaryTitle')}
                body={t('errors.boundaryBody')}
                action={<Button onClick={() => window.location.reload()}>{t('errors.reload')}</Button>}
            />
        </div>
    );
};

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
    state: ErrorBoundaryState = { hasError: false };

    static getDerivedStateFromError(): ErrorBoundaryState {
        return { hasError: true };
    }

    componentDidCatch(error: Error, info: React.ErrorInfo) {
        console.error('Uncaught error:', error, info);
    }

    render() {
        return this.state.hasError ? <Fallback /> : this.props.children;
    }
}

export default ErrorBoundary;
